import {
  Component,
  ComponentFactory,
  ComponentFactoryResolver,
  ComponentRef,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { EdtellFooterHelperDirective } from "../directives/edtell-footer-helper.directives";
import { EdtellFooterService } from "../service/edtell-footer.service";

@Component({
  selector: "app-edtell-footer",
  templateUrl: "./edtell-footer.component.html",
  styleUrls: ["./edtell-footer.component.scss"],
})
export class EdtellFooterComponent implements OnInit {
  @ViewChild(EdtellFooterHelperDirective, { static: false })
  injectionPoint: EdtellFooterHelperDirective;

  constructor(
    private edtellFooterService: EdtellFooterService,
    private componentFactoryResolver: ComponentFactoryResolver,
  ) {}

  ngOnInit() {
    this.edtellFooterService.footerState.subscribe(async (navComponent) => {
      const routeParams: any = await this.edtellFooterService.getRouteParams();
      if (navComponent == undefined) {
        return;
      }
      const componentFactory: ComponentFactory<any> =
        this.componentFactoryResolver.resolveComponentFactory(navComponent);

      const viewRef: ViewContainerRef = this.injectionPoint.viewContainerRef;

      viewRef.clear();
      const c: ComponentRef<any> = viewRef.createComponent(componentFactory);
    });
  }
}
